const React = require("react");
const ReactIntl = require("react-intl");
const injectIntl = ReactIntl.injectIntl;
var defaultMessages = require("../../i18n/messages/default");

const { Text, Description } = require("@metro-ui/core");
var defaultMessages = require("../../i18n/messages/default");

class ResendCodeTimer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      initialSeconds: props.seconds,
      initialMessage: props.initialMessage,
      seconds: props.seconds,
      sendOtp: props.sendOtp,
      secondsCounterInterval: null,
      isResendCodeAvailable: false,
      countMaxTries: 0,
    };
  }

  createSecondsInterval() {
    return setInterval(() => {
      const { initialSeconds, seconds, secondsCounterInterval } = this.state;

      this.setState({ seconds: seconds - 1 });

      if (seconds === 1) {
        this.setState({
          isResendCodeAvailable: true,
          secondsCounterInterval: null,
        });
        clearInterval(secondsCounterInterval);
        this.setState({ seconds: initialSeconds });
      }
      return () => {
        clearInterval(secondsCounter);
      };
    }, 1000);
  }

  componentDidMount() {
    const secondsCounter = this.createSecondsInterval();
    this.setState({ secondsCounterInterval: secondsCounter });
  }

  componentWillUnmount() {
    const { secondsCounterInterval } = this.state;
    clearInterval(secondsCounterInterval);
  }

  render() {
    const { isResendCodeAvailable, countMaxTries, sendOtp } = this.state;
    const { maxTries } = this.props;

    return (
      <div className="resend-code-timer">
        <Text>Did not receive the code ?</Text>

        {isResendCodeAvailable ? (
          countMaxTries !== maxTries ? (
            <Text
              className="primary-color"
              size="medium"
              color="metro-blue"
              onClick={() => {
                const counter = this.createSecondsInterval();
                this.setState({
                  secondsCounterInterval: counter,
                  isResendCodeAvailable: false,
                  countMaxTries: countMaxTries + 1,
                });
                sendOtp();
              }}
            >
              {this.props.intl.formatMessage(
                defaultMessages[
                  "loginpreferences.2famethods.codes_via_sms.resend_otp_multiple_2fa"
                ]
              )}
            </Text>
          ) : (
            <Description color="danger">
              Verification failed. Try other 2FA methods to secure your account.
            </Description>
          )
        ) : (
          <Description>Resend Code (in {this.state.seconds}s)</Description>
        )}
      </div>
    );
  }
}

module.exports = injectIntl(ResendCodeTimer);
